<template>
  <div>
    <div
      v-if="!isLoadingReport"
      class="h-24 report-engagement-rate-percent"
    >
      <div class="report-engagement-rate-percent__progress">
        <aha-progress-circle
          progress-bar-color="#6A1EBB"
          :percent="roundedEngagementRate"
          :radius="30"
          :ring-width="12"
          box-shadow="2px 4px 6px rgba(106, 30, 187, 0.12)"
          inner-box-shadow="inset 1px 1px 6px rgba(106, 30, 187, 0.12)"
        />
        <span
          class="report-engagement-rate-percent__number"
          v-if="roundedEngagementRate !== null"
        >{{ roundedEngagementRate + '%' }}</span>
      </div>
      <div class="report-engagement-rate-percent__text">
        <h4 class="mb-1 text-lg" v-if="engagementLevel">
          <span class="font-bold"> <!-- AHA-8215 -->
            {{ $i18nPresenter.t(engagementLevel.title) }}
          </span>
          <span v-if="showIcon">
            {{ engagementLevel.icon }}
          </span>
        </h4>
        <p class="text-md14-h18 text-base-90" v-if="engagementRate">
          {{ roundedEngagementRate + '%' }} {{ $i18nPresenter.t('of participants interacted with this presentation.') }}
          <span v-if="showTooltip">
            <i

              class="fas fa-question-circle text-secondary-40"
              v-tooltip="totalResponsesTooltip"
            />

          </span>
        </p>
        <p class="text-md14-h18 text-base-90" v-else>
          {{ $i18nPresenter.t('Invite people to join your presentation and start engaging!') }}
        </p>
      </div>
    </div>
    <report-engagement-rate-skeleton v-else />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ReportEngagementRateSkeleton from './ReportEngagementRateSkeleton.vue'

export default {
  components: { ReportEngagementRateSkeleton },
  props: {
    engagementRate: {
      type: Number,
      default: null,
    },
    engagementLevel: {
      type: Object,
      default: () => ({}),
    },
    totalInteractions: {
      type: Number,
      default: 0,
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('presentationReport', [
      'isLoadingReport',
    ]),
    roundedEngagementRate() {
      return (this.engagementRate && Math.round(this.engagementRate * 100)) || 0
    },
    totalResponsesTooltip() {
      return {
        content: this.$i18nPresenter.t("An 'interaction' is any of these actions from a participant:<br/> - A reaction<br/> - A Q&A question<br/> - A submitted response."),
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .report-engagement-rate-percent {
    @apply flex flex-row items-center p-2;
  }
  .report-engagement-rate-percent__progress {
    @apply mr-3 relative;
  }
  .report-engagement-rate-percent__number {
    @apply absolute top-0 left-0;
    @apply w-full h-full flex items-center justify-center;
    @apply font-bold;
  }
</style>
